module.exports = __webpack_public_path__ + "static/img/11-11.2c28ba6d.jpeg";